import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFoundRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const auth = localStorage.getItem("auth");
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const userRole = user?.user?.role;
    if (!auth) {
      navigate("/", { replace: true });
    } else if (userRole === "Admin") {
      navigate("/admin-dashboard", { replace: true });
    } else if (userRole === "Staff") {
      navigate("/staffDashboard", { replace: true });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);
  return null;
};

export default NotFoundRedirect;
